import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store';
import {
  fetchNotifications,
  setHasFetched,
} from '@store/slices/notificationsSlice';

/**
 * Initializer component for notifications
 * Fetches notifications when the component mounts if not already fetched
 * Only fetches if userToken is set (regular user session, not client folder access)
 */
export const NotificationsInitializer = () => {
  const dispatch = useAppDispatch();
  const { hasFetched, notifications, isLoading } = useAppSelector(
    (state) => state.notifications
  );

  useEffect(() => {
    // Only fetch notifications if userToken is set
    const userToken = localStorage.getItem('userToken');

    if (!userToken) {
      // No user token, skip fetching notifications
      if (!hasFetched) {
        dispatch(setHasFetched(true));
      }
      return;
    }

    if (!hasFetched && !isLoading) {
      // If notifications are already loaded (e.g., from WebSocket), mark as fetched
      if (notifications.length > 0) {
        dispatch(setHasFetched(true));
      } else {
        dispatch(fetchNotifications({ skip: 0, limit: 50 }));
      }
    }
  }, [dispatch, hasFetched, notifications.length, isLoading]);

  return null;
};
